import "../../../styles/stores/stockManagement/sizeWishes.css";

import EachSizeOrColorSelected from "./EachSizeOrColorSelected";
import { useState, useEffect, useLayoutEffect } from "react";
import { BsArrowDownShort } from "react-icons/bs";
import { IoClose } from "react-icons/io5";

/* disregard the term "training" that was used here.  */

const mockTrainings = [
  { id: `${Math.random() * 100}`, name: "Xtra small (XS)", code: "XS" },
  { id: `${Math.random() * 100}`, name: "Small (S)", code: "S" },
  { id: `${Math.random() * 100}`, name: "Meduim (M)", code: "M" },
  { id: `${Math.random() * 100}`, name: "Large (L)", code: "L" },
  { id: `${Math.random() * 100}`, name: "xtra Large (XL)", code: "XL" },
  { id: `${Math.random() * 100}`, name: "xtra xtra Large (XXL)", code: "XXL" },
];

const Wishes = ({ closeModalWithSizeFalse, closeModalWithSizeTrue, updateSelectedSize }) => {
  const [selectedTrainings, setSelectedTrainings] = useState([]);
  const [openDropDown, setOpenDropDown] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    if (selectedTrainings.length > 0) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [selectedTrainings]);

  const toggleDropDown = () => {
    openDropDown ? setOpenDropDown(false) : setOpenDropDown(true);
  };

  const addSelectedTraining = (training) => {
    let match = selectedTrainings.find((train) => train.id === training.id);
    if (!match) {
      setSelectedTrainings([...selectedTrainings, training]);
    }
  };

  const removeSelectedTraining = (training) => {
    let filteredTrainings = selectedTrainings.filter((train) => train.id !== training.id);
    setSelectedTrainings(filteredTrainings);
  };
  const submitSelectedSizes = () => {
    updateSelectedSize(selectedTrainings);
    closeModalWithSizeTrue(false);
  };

  return (
    <>
      <div onClick={() => closeModalWithSizeFalse(false)} className='wishesListWrapper'>
        <div onClick={(e) => e.stopPropagation()} className='wishesWrapper994'>
          <div onClick={() => toggleDropDown()} className='selectTrainingsDropDown'>
            <p>Select available sizes for the product</p>
            {openDropDown ? (
              <span className='closeDropDownSpan'>
                <IoClose />{" "}
              </span>
            ) : (
              <BsArrowDownShort size={20} />
            )}
            {openDropDown && (
              <div className='dropDownMenu12'>
                {mockTrainings.map((training, i) => (
                  <p
                    key={i}
                    onClick={(e) => {
                      addSelectedTraining(training);
                      //e.stopPropagation();
                    }}
                  >
                    {" "}
                    {training.name}{" "}
                  </p>
                ))}
              </div>
            )}
          </div>
          {selectedTrainings.length > 0 && (
            <div className='selectedTrainingsDIv'>
              {selectedTrainings.map((training, i) => (
                <EachSizeOrColorSelected key={i} training={training} deleteTraining={removeSelectedTraining} />
              ))}
            </div>
          )}

          <div className='SubmitSelection123'>
            {isFormValid ? (
              <button onClick={submitSelectedSizes}>Submit sizes</button>
            ) : (
              <button style={{ cursor: "not-allowed", backgroundColor: "white", opacity: "0.6" }} disabled>
                Submit sizes
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Wishes;
